import { useState } from "react";
import { YouTubeGlyph } from "./icons";

/** A small red pill. With `href` it opens that video directly; otherwise it opens
 *  a YouTube search ("<title> chant liturgique", or `query`). */
export function YouTubeLink({ title, query, href }: { title: string; query?: string; href?: string }) {
  const [hover, setHover] = useState(false);
  if (!title.trim() && !query?.trim() && !href) return null;
  const url = href || "https://www.youtube.com/results?search_query=" + encodeURIComponent(query || title + " chant liturgique");
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label={`Écouter « ${title} » sur YouTube`}
      style={{
        display: "inline-flex", alignItems: "center", gap: 7, textDecoration: "none",
        fontFamily: "var(--font-ui)", fontSize: "var(--text-sm)", fontWeight: 600,
        color: "#c4302b", background: hover ? "#fdecea" : "var(--bg-raised)",
        border: "1px solid #f0c4c0", borderRadius: "var(--radius-pill)",
        padding: "4px 11px 4px 9px",
        transition: "background var(--dur-fast) var(--ease-out)",
      }}
    >
      <YouTubeGlyph size={16} />
      Écouter
    </a>
  );
}
